import React from "react";

const TermsTab: React.FC = () => {
  return (
    <div
      style={{
        height: "100%",
        overflowY: "auto",
        paddingLeft: "10px",
        paddingRight: "10px",
      }}
    >
      <h3>Terms of Use</h3>
      <h4>Last Updated: February 24, 2025 </h4>
      <p>
        Welcome to the Ross License Tool ("Website"), owned and operated by Ross
        Video Limited (“Ross” or “we” or “us” as the context indicates). These
        Terms of Use ("Terms") govern your access to and use of our website and
        services, including the generation and distribution of software
        activation keys ("Services"). By accessing or using Ross’s Website, you
        agree to be bound by these Terms. If you do not agree, please do not use
        our Services.
      </p>
      <ol>
        <li>Eligibility </li>
        <ul>
          <li>
            To be eligible to use this Website, you must have an active account
            with Ross.
          </li>
          <li>
            You must also comply with the following export control rules: (a)
            You are not located in a country that is subject to a United States
            Government embargo, or that is on Title 15, Part 740 Supplement 1
            Country Group E of the United States Code of Federal Regulations;
            (b) You are not located in a country that has been designated by the
            United States Government as a "terrorist supporting" country; (c)
            You are not listed on any U.S. Government list of prohibited or
            restricted parties; (d) You are not located in, under the control
            of, or a national or resident of any country subject to trade
            restrictions, economic sanctions, or embargoes imposed by Canada,
            the European Union, or any other applicable jurisdiction; and (e)
            You are not listed on any Canadian or European Union restricted
            parties list or any other similar international sanction lists.
          </li>
          <li>
            You further agree not to use the activation keys in any such
            restricted country.
          </li>
        </ul>
        <li>Use of Services and Activation Keys </li>
        <ul>
          <li>
            You agree to use the Services in compliance with all applicable laws
            and regulations.
          </li>
          <li>
            You agree not to use the Services for any fraudulent, unlawful, or
            unauthorized purposes.
          </li>
          <li>
            An activation key may only be used with the server that generated
            it. You agree not to tamper with an activation key or otherwise
            transfer or seek to transfer an activation key to another computer
            or user.
          </li>
          <li>
            You agree not to resell, redistribute, or misuse activation keys in
            a way that violates Ross’s end user license agreement or any other
            terms and conditions prescribed by Ross in connection with the
            software for which the activation keys are issued.
          </li>
        </ul>
        <li>Your Account</li>
        <ul>
          <li>
            Your account with Ross must be in good standing in order for you to
            access the Services.
          </li>
          <li>
            You are responsible for maintaining the confidentiality of your
            account credentials with Ross.
          </li>
          <li>Any activity under your account is your responsibility.</li>
        </ul>
        <li>Intellectual Property</li>
        <ul>
          <li>
            All content on this Website, including logos, text, and graphics, is
            owned or licensed by us and protected under applicable copyright and
            other intellectual property laws.
          </li>
          <li>
            You may not copy, modify, or distribute any content without our
            written permission.
          </li>
        </ul>
        <li>Limitation of Liability</li>
        <ul>
          <li>
            We are not responsible for any direct, indirect, incidental, or
            consequential damages resulting from the use or inability to use our
            Services.
          </li>
          <li>
            Activation keys are for one-time use only. Once you use an
            activation key, it expires.
          </li>
        </ul>
        <li>Termination</li>
        <ul>
          <li>
            We reserve the right to terminate or suspend your access to the
            Website if you violate these Terms.
          </li>
          <li>
            Upon termination, any rights granted to you under these Terms will
            cease immediately.
          </li>
        </ul>
        <li>Changes to These Terms</li>
        <ul>
          <li>
            We reserve the right to modify these Terms at any time. Changes will
            be effective upon posting on our Website.
          </li>
          <li>
            Your continued use of the Services constitutes acceptance of the
            revised Terms.
          </li>
        </ul>
        <li>Contact Information</li>
        <ul>
          <li>
            If you have any questions about these Terms, please contact us at
            support@rossvideo.com.
          </li>
        </ul>
      </ol>
    </div>
  );
};

export default TermsTab;
